<template>
  <el-form-item ref="batchMaintenanceForm" class="sky-batch-maintenance-url-link">
    <div v-if="this.maintenance.maintenanceStatus === 'EXPORTED'" class="order-status text">
      已导出：<el-button type="text" @click="openUrl">打开飞书在线表格进行编辑</el-button>
    </div>
    <div v-else-if="this.maintenance.maintenanceStatus === 'IMPORTED'" class="order-status text">
      <sk-icon-status type="success" content="规格配置数据导入成功"></sk-icon-status>
      <div>场景新增：{{ this.maintenance.sceneAdd }}</div>
      <div>场景修改：{{ this.maintenance.sceneUpdate }}</div>
      <div>功能新增：{{ this.maintenance.featureAdd }}</div>
      <div>功能修改：{{ this.maintenance.featureUpdate }}</div>
      <div>用例新增：{{ this.maintenance.testCaseAdd }}</div>
      <div>用例修改：{{ this.maintenance.testCaseUpdate }}</div>
    </div>
    <div v-else-if="this.maintenance.maintenanceStatus === 'EXPORTING'" class="order-status text">
      <sk-icon-status type="ing" content="规格数据导出中..."></sk-icon-status>
    </div>
    <div v-else-if="this.maintenance.maintenanceStatus === 'IMPORTING'" class="order-status text">
      <sk-icon-status type="ing" content="规格数据导入中..."></sk-icon-status>
    </div>
    <div
      v-else-if="
        this.maintenance.maintenanceStatus === 'IMPORT_ERROR' ||
          this.maintenance.maintenanceStatus === 'EXPORT_ERROR' ||
          this.maintenance.maintenanceStatus === 'TIMEOUT'
      "
      class="order-status text"
    >
      <sk-icon-status type="error" :content="this.maintenance.msg"></sk-icon-status>
    </div>
  </el-form-item>
</template>
<script type="text/babel">
import { Button } from 'element-ui'
import { SkIconStatus } from 'sk-ui'

import { getMaintenanceStatus } from '../api/setting'
export default {
  name: 'SkyBatchMaintenanceUrlLink',
  inject: ['rootView', 'elForm'],
  components: {
    [Button.name]: Button,
    [SkIconStatus.name]: SkIconStatus
  },
  props: {
    buildStatus: {
      type: String,
      default: ''
    }
  },
  data() {
    return { maintenance: {}, timer: null }
  },
  mounted() {
    this.maintenanceStatus()
  },
  watch: {
    buildStatus: {
      handler: function(newValue, oldValue) {
        this.showDoing()
        var cnt = 0
        clearInterval(this.timer)
        this.timer = setInterval(() => {
          cnt++
          if (cnt > 90) {
            this.maintenance.maintenanceStatus = 'TIMEOUT'
            this.maintenance.msg = '请求超时，请重新再试'
            clearInterval(this.timer)
            return
          }
          this.maintenanceStatus()
        }, 2000)
      }
    }
  },
  methods: {
    showDoing() {
      if (
        this.buildStatus.startsWith('IM') &&
        this.maintenance?.maintenanceStatus != 'EXPORTING' &&
        this.maintenance?.maintenanceStatus != 'IMPORTED'
      ) {
        this.maintenance.maintenanceStatus = 'IMPORTING'
      }
      if (this.buildStatus.startsWith('EX') && this.maintenance?.maintenanceStatus != 'IMPORTING') {
        this.maintenance.maintenanceStatus = 'EXPORTING'
      }
    },
    openUrl() {
      window.open(this.maintenance.url, '_blank')
    },
    maintenanceStatus() {
      getMaintenanceStatus({})
        .then(response => {
          if (response?.data?.status === 'SUCCESS') {
            this.maintenance = response.data.content

            if (
              this.maintenance.maintenanceStatus === 'IMPORT_ERROR' ||
              this.maintenance.maintenanceStatus === 'EXPORT_ERROR' ||
              this.maintenance.maintenanceStatus === 'EXPORTED' ||
              this.maintenance.maintenanceStatus === 'IMPORTED'
            ) {
              clearInterval(this.timer)
            }
          } else {
            clearInterval(this.timer)
            console.error(response)
          }
        })
        .catch(e => {
          console.error(e.message)
          clearInterval(this.timer)
        })
    }
  }
}
</script>
